import { IAddress } from '@@types/address';
import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '@stores/store';

export type TAddressInitialState = {
  address: IAddress[];
  currentAddress: IAddress | undefined;
};

const initialState: TAddressInitialState = {
  address: [],
  currentAddress: undefined,
};

export const addressSelector = (state: RootState) => state.address;

export const popupSlice = createSlice({
  name: 'address',
  initialState,
  reducers: {
    storeAddress: (state, action) => {
      state = action.payload;
      return state;
    },
    setCurrentAddress: (state, action) => {
      state.currentAddress = action.payload;
      return state;
    },
  },
});

export const { storeAddress, setCurrentAddress } = popupSlice.actions;

export default popupSlice.reducer;
